import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileBottomBar from "@/components/feature/MobileBottomBar";
import CookieConsent from "@/components/feature/CookieConsent";
import HeroSection from "./components/HeroSection";
import WelcomeSection from "./components/WelcomeSection";
import AdventEventSection from "./components/AdventEventSection";
import ServiceCards from "./components/ServiceCards";
import GoogleReviews from "./components/GoogleReviews";
import ContactTeaser from "./components/ContactTeaser";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <WelcomeSection />
        <AdventEventSection />
        <ServiceCards />
        <GoogleReviews />
        <ContactTeaser />
      </main>
      <Footer />
      <MobileBottomBar />
      <CookieConsent />
    </>
  );
}